import { computed, Injectable, signal } from '@angular/core';
import { uid } from '../utils/mock';

type LoaderEntry = {
  id: string;
  message: string;
  startedAt: number;
};

@Injectable({ providedIn: 'root' })
export class LoaderService {
  private readonly entriesState = signal<LoaderEntry[]>([]);

  readonly entries = this.entriesState.asReadonly();
  readonly isLoading = computed(() => this.entriesState().length > 0);
  readonly activeCount = computed(() => this.entriesState().length);
  readonly message = computed(() => this.entriesState().at(-1)?.message ?? '');

  begin(message: string): string {
    const id = uid('loader');

    this.entriesState.update((entries) => [
      ...entries,
      {
        id,
        message: message.trim() || 'Loading',
        startedAt: Date.now(),
      },
    ]);

    return id;
  }

  end(id: string): void {
    this.entriesState.update((entries) => entries.filter((entry) => entry.id !== id));
  }

  clear(): void {
    this.entriesState.set([]);
  }
}
